// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-container {
    z-index: 5;
    height: 100vh;
}

.CadastroFarm #map{
    width: 100vw;
   
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/CadastroFarm.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,YAAY;;AAEhB","sourcesContent":[".leaflet-container {\n    z-index: 5;\n    height: 100vh;\n}\n\n.CadastroFarm #map{\n    width: 100vw;\n   \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
